import React, { useEffect } from 'react'

import { useAuth } from '@fourthwall/auth'
import { Loader } from '@fourthwall/components'
import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { isProduction } from '@fourthwall/utils'
import { routing } from '@utils/routing'

export const AppsKitAuthorize = () => {
  const { keycloak } = useAuth()
  useEffect(() => {
    if (!keycloak?.token) return
    const kitRedir = isProduction()
      ? 'https://app.kit.com/apps/567?success=true'
      : 'https://app.kit.com/apps/569?success=true'

    const returnUrl = `${window.location.origin}${routing.apps.kit.self}?kitReturn=${kitRedir}`

    const url = CreatorIntegrationsApiClient.appAuthorizationUrl({
      app: 'kit',
      token: keycloak?.token,
      returnUrl,
    })

    window.location.assign(url)
  }, [keycloak])

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
    >
      <Loader size="large" />
    </div>
  )
}
